<div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
  <div
    class="full-width"
    fxLayout="column"
    fxLayout.gt-md="row"
    fxLayoutAlign="space-between center"
  >

    <button class="responsive-table-desktop" mat-raised-button color="primary" (click)="goToAddUser()">
      <mat-icon>add_circle</mat-icon> Adicionar Usuário
    </button>

    <button class="responsive-table-mobile" fxFill mat-raised-button color="primary" (click)="goToAddUser()">
      <mat-icon>add_circle</mat-icon> Adicionar Usuário
    </button>

    <div
      fxFill
      fxFlex.gt-md
      fxLayout.gt-md="row"
      fxLayoutAlign.gt-md="end center"
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutGap="15px"
    >
      <mat-slide-toggle
        class="responsive-table-desktop"
        [(ngModel)]="showAllUsers"
        fxFlex="20"
        color="primary"
      >
        Mostrar inativos
      </mat-slide-toggle>
      <mat-slide-toggle
        class="responsive-table-mobile"
        [(ngModel)]="showAllUsers"
        color="primary"
        style="padding-top: 10px;"
      >
        Mostrar inativos
      </mat-slide-toggle>
      <mat-form-field fxFlex.gt-md="40" fxFill appearance="outline">
        <input matInput [formControl]="searchControl" />
        <mat-label>Buscar usuário</mat-label>
      </mat-form-field>
    </div>
  </div>

  <table
    mat-table
    [dataSource]="items"
    class="mat-elevation-z1 responsive-table-desktop"
    style="width: 100%"
  >
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let user">{{ user.id }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let user">{{ user.name }}</td>
    </ng-container>

    <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef>Telefone</th>
      <td mat-cell *matCellDef="let user">
        {{ apiService.nineExtra(user.mobile) | mask: apiService.phoneMask }}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let user">{{ user.email }}</td>
    </ng-container>

    <ng-container matColumnDef="business">
      <th mat-header-cell *matHeaderCellDef>Empresa</th>
      <td mat-cell *matCellDef="let user" class="truncate">
        {{ user.business ? user.business.name : "SEM EMPRESA" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="can_see_all">
      <th mat-header-cell *matHeaderCellDef>Admin?</th>
      <td mat-cell *matCellDef="let user" class="truncate">
        {{ user.can_see_all ? "SIM" : "NÃO" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="options">
      <th mat-header-cell *matHeaderCellDef>
        <strong><u>Editar</u></strong>
      </th>
      <td mat-cell *matCellDef="let user">
        <button
          mat-icon-button
          color="primary"
          aria-label="Select the business"
          (click)="editUser(user)"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          color="warn"
          aria-label="Select the business"
          (click)="removeUser(user)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <app-list-user-responsive
    class="responsive-table-mobile"
    [items]="items"
  ></app-list-user-responsive>
</div>
<mat-paginator
  fxFill
  class="responsive-paginator"
  [length]="length"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="setPage = $event"
>
</mat-paginator>
